import styled from 'styled-components';

export const AlternativeNamesSection = styled.div`
  margin-top: 16px;
  padding: 16px;
`;

export const UnsavedChangesIndicator = styled.div`
  background-color: ${({ theme }) => theme.colors.blueLight || '#E3F2FD'};
  color: ${({ theme }) => theme.colors.blueMain || '#1976D2'};
  border: 1px solid ${({ theme }) => theme.colors.blueMain || '#1976D2'};
  padding: 10px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.redMain};
  background-color: ${({ theme }) => theme.colors.redLight};
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
`;

export const AddAlternativeForm = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const AlternativeInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease-in-out;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.blueMain};
  }
`;

export const AddButton = styled.button`
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.blueMain};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.blueDark};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grey003};
    cursor: not-allowed;
  }
`;

export const AlternativeNamesList = styled.div`
  height: 300px;
  overflow-y: auto;
`;

export const AlternativeNameItem = styled.div`
  margin-bottom: 8px;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  transition: all 0.3s ease-in-out;
  height: 35px;
  display: flex;
  align-items: center;
`;

export const AlternativeNameDisplay = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease-in-out;
`;

export const AlternativeNameText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black};
  flex: 1;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
`;

export const EditButton = styled.button`
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.blueMain};
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.blueDark};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DeleteButton = styled.button`
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.redMain};
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.redDark};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const NoAlternativesText = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.grey002};
  font-style: italic;
  padding: 20px;
`;

export const LoadingText = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.blueMain};
  padding: 20px;
  font-style: italic;
`;
